export default __webpack_public_path__ + "static/Rubamin-c4c8b2f0743a19e6f0575ee8bf8278a9.jpg";